import { useLocation } from "react-router-dom";

const useUrlSearchParams = (param: string) => {
  const queryParams = useLocation();
  const filterParams = new URLSearchParams(queryParams.search);
  const paramField: string | number = filterParams.get(param);

  return paramField;
};

export default useUrlSearchParams;
